import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function TermsOfServicePage() {
  return (
    <div style={{ 
      position: 'relative', 
      zIndex: 1, 
      paddingTop: '100px',
      paddingBottom: '80px',
      minHeight: '100vh',
      background: '#0a1628',
    }}>
      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '0 24px' }}>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: 'var(--vvs-muted)',
            textDecoration: 'none',
            fontSize: '11px',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            fontFamily: 'Space Grotesk',
            marginBottom: '40px',
            transition: 'color 0.3s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#F0F4F8'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--vvs-muted)'}
        >
          <ChevronLeft size={14} /> Home
        </Link>

        <h1 style={{
          fontFamily: 'Syne, sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(32px, 6vw, 48px)',
          textTransform: 'uppercase',
          color: '#F0F4F8',
          marginBottom: '16px',
          letterSpacing: '-0.02em',
        }}>
          Terms of Service
        </h1>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '12px', 
          color: 'var(--vvs-muted)', 
          marginBottom: '48px',
          letterSpacing: '0.1em',
        }}>
          Last updated: February 2026
        </p>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '14px', 
          color: 'var(--vvs-muted)', 
          lineHeight: 1.9,
          marginBottom: '16px',
        }}>
          By accessing vaguevisionsound.com, you agree to these Terms of Service.
        </p>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '14px', 
          color: 'var(--vvs-muted)', 
          lineHeight: 1.9,
          marginBottom: '40px',
        }}>
          Nothing in these Terms affects your statutory rights under applicable Belgian and European consumer protection law.
        </p>

        <div style={{ color: '#F0F4F8', fontFamily: 'Space Grotesk, sans-serif', fontSize: '14px', lineHeight: 1.9 }}>
          <Section number="1" title="Use of the Website">
            <p style={{ color: 'var(--vvs-muted)' }}>
              This website is operated by Vague Vision Sound ASBL, Rue du Trône 214/7, 1050 Ixelles, Brussels, Belgium. Content is provided for informational and cultural purposes only. You may not reproduce, distribute, or commercially exploit any content without prior written permission from VVS.
            </p>
          </Section>

          <Section number="2" title="Intellectual Property">
            <p style={{ color: 'var(--vvs-muted)' }}>
              All content on this website // including music, visuals, text, logos, and event materials // is the property of Vague Vision Sound ASBL or its respective creators and is protected by applicable intellectual property law. Legal exceptions (quotation, private use) remain applicable.
            </p>
          </Section>

          <Section number="3" title="Ticket Purchases & Events">
            <p style={{ color: 'var(--vvs-muted)' }}>
              Ticket sales for VVS events are subject to our <Link to="/legal/refund" style={{ color: 'var(--vvs-cyan)', textDecoration: 'none' }}>Refund Policy</Link> and our <Link to="/legal/events" style={{ color: 'var(--vvs-cyan)', textDecoration: 'none' }}>Event Terms & Conditions</Link>, which include health and safety warnings for immersive experiences. Please read both documents carefully before purchasing.
            </p>
          </Section>

          <Section number="4" title="Limitation of Liability">
            <p style={{ color: 'var(--vvs-muted)' }}>
              VVS is not liable for any indirect, incidental, or consequential damages arising from the use of this website or attendance at VVS events, except where required by law.
            </p>
          </Section>

          <Section number="5" title="External Links">
            <p style={{ color: 'var(--vvs-muted)' }}>
              This website may contain links to third-party websites. VVS is not responsible for the content or practices of those sites.
            </p>
          </Section>

          <Section number="6" title="Changes to These Terms">
            <p style={{ color: 'var(--vvs-muted)' }}>
              VVS reserves the right to update these Terms at any time. Continued use of the website constitutes acceptance of the updated Terms.
            </p>
          </Section>

          <Section number="7" title="Governing Law">
            <p style={{ color: 'var(--vvs-muted)' }}>
              These Terms are governed by Belgian law. Disputes will be handled by the competent courts under Belgian law, to the extent permitted by applicable consumer protection rules.
            </p>
            <p style={{ color: 'var(--vvs-muted)', marginTop: '16px' }}>
              Contact: contact@vaguevisionsound.com
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ number, title, children }) {
  return (
    <div style={{ marginBottom: '40px' }}>
      <h2 style={{
        fontFamily: 'Syne, sans-serif',
        fontWeight: 700,
        fontSize: '16px',
        textTransform: 'uppercase',
        color: 'var(--vvs-cyan)',
        marginBottom: '16px',
        letterSpacing: '0.08em',
      }}>
        {number}. {title}
      </h2>
      {children}
    </div>
  );
}
